import { defineStore } from 'pinia';
type StoreStateType = {
	pushData: string;
};
export const usePushStore = defineStore('push', {
	state: (): StoreStateType => {
		return {
			pushData: '',
		};
	},
	actions: {
		setPushData(data: string) {
			this.pushData = data;
		},
	},
	persist: true,
});
